import React, { Component } from 'react';
import { Form, Field } from 'redux-form';
import PropTypes from 'prop-types';

import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';
import FormLabel from '@material-ui/core/FormLabel';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import ErrorIcon from '@material-ui/icons/Error';

import {
  RenderTextField as TextField,
  RenderDropDownField as DropDown, RenderSwitchField as Switch,
  UploadField, RenderRadioGroupField as RadioGroup,
} from '../../formInputs';
import Message from '../Message';
import FilesList from '../FileLists';

import { required, integer } from '../../utils/validations';
import { getTimeline } from '../../redux/modules/property/action';

import { PROPERTY_FILES_FOLDER } from '../../constants';


const styles = theme => ({
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  form: {
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
  success: {
    // backgroundColor: green500,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  error: {
    marginTop: 10,
    color: '#ffffff',
    backgroundColor: theme.palette.error.dark,
  },
  snackbar: {
    margin: theme.spacing.unit,
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 320,
  },
  title: {
    marginTop: 10,
  },
  radioBtn: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  fullField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  }
});

class PropertyForm extends Component {
  static propTypes = {
    classes: PropTypes.object,
    handleSubmit: PropTypes.func,
    user: PropTypes.object,
    removeMessage: PropTypes.func,
    error: PropTypes.string,
    addProperty: PropTypes.func
  };

  state = {
    isPetFriendly: this.props.isPet
  }


  handleChangeIsFriendly = () => {
    const { isPetFriendly } = this.state;
    this.setState({ isPetFriendly: !isPetFriendly });
  }

  renderFields = (fields) => {
    if (fields.length > 0) {
      return fields.map(f => {
        let props;
        if (f.inputProps) {
          props = f.inputProps
        }

        return (
          <FormControl margin="normal" className={f.className} fullWidth={f.fullWidth}>
            {f.text &&
              <FormLabel component="legend">{f.text}</FormLabel>
            }
            <Field
              name={f.name}
              component={f.component}
              label={f.label}
              required={f.required}
              InputProps={props}
              {...f}
            />
          </FormControl>
        )
      })
    }
  }

  render() {
    const {
      classes,
      handleSubmit,
      addProperty,
      message,
      error,
      propertyImages,
      deleteImage,
      formName,
      userList,
      timelineDetails,
      getTimelineIds
    } = this.props;

    const { isPetFriendly } = this.state;

    const users = userList.map(u => {
      return {
        label: `${u.userDetail && u.userDetail.firstName} ${u.userDetail && u.userDetail.lastName}`,
        value: u.id
      }
    });

    const fields = [
      {
        name: 'title',
        component: TextField,
        required: true,
        label: 'Title',
        fullWidth: true,
        className: classes.fullField
      },
      {
        name: 'userId',
        component: DropDown,
        helperText: "Select User",
        options: users || [],
        required: true,
        text: 'User',
        className: classes.textField,
        onChange: (e) => getTimelineIds(e)
      },
      {
        name: 'timelineId',
        component: DropDown,
        helperText: "Select Timeline Id",
        options: timelineDetails ? timelineDetails.map(t => {
          return {
            value: t.id,
            label: `${t.house} - ${t.unit} - ${t.address}`
          }
        }) : [],
        required: true,
        text: 'Timeline Id',
        className: classes.textField
      },
      {
        name: 'address',
        component: TextField,
        required: true,
        label: 'Address',
        className: classes.textField
      },
      {
        name: 'city',
        component: TextField,
        required: true,
        label: 'City',
        className: classes.textField
      },
      {
        name: 'state',
        component: TextField,
        required: true,
        label: 'State',
        className: classes.textField
      },
      {
        name: 'zip',
        component: TextField,
        required: true,
        label: 'Zip',
        className: classes.textField
      },
      {
        name: 'country',
        component: TextField,
        required: true,
        label: 'Country',
        className: classes.textField
      },
      {
        name: 'type',
        component: DropDown,
        required: true,
        label: 'Type',
        className: classes.textField,
        options: [{
          label: 'Kothi',
          value: 'Kothi'
        },
        {
          label: 'Apartment',
          value: 'Apartment'
        },
        {
          label: 'Flat',
          value: 'Flat'
        }]
      },
      {
        name: 'bathrooms',
        component: RadioGroup,
        label: 'Bathrooms',
        text: 'Bathrooms',
        className: classes.textField,
        options: [
          {
            text: '1',
            value: 1
          },
          {
            text: '2',
            value: 2
          },
          {
            text: '3',
            value: 3
          },
          {
            text: '4',
            value: 4
          }
        ]
      },
      {
        name: 'bedrooms',
        component: RadioGroup,
        label: 'Bedrooms',
        text: 'Bedrooms',
        className: classes.textField,
        options: [
          {
            text: '1',
            value: 1
          },
          {
            text: '2',
            value: 2
          },
          {
            text: '3',
            value: 3
          },
          {
            text: '4',
            value: 4
          }
        ]
      
      },
      {
        name: 'videoLink',
        component: TextField,
        label: 'Video Link',
        className: classes.textField
      },
      {
        name: 'rentAmount',
        component: TextField,
        required: true,
        label: 'Rent Amount',
        className: classes.textField,
        validate: integer,
        inputProps: {
          endAdornment: (
            <InputAdornment variant="filled" position="end">
              $
            </InputAdornment>
          ),
        }
      },
      {
        name: 'leaseTerm',
        component: TextField,
        required: true,
        label: 'Lease Term Period',
        className: classes.textField,
        inputProps: {
          endAdornment: (
            <InputAdornment variant="filled" position="end">
              Days
            </InputAdornment>
          ),
        }
      },
      
      {
        name: 'isPet',
        component: Switch,
        checked: isPetFriendly,
        onChange: this.handleChangeIsFriendly,
        fullWidth: true,
        text: 'Is Pet Friendly ?',
        className: classes.radioBtn
      },
      {
        name: 'description',
        component: TextField,
        required: true,
        label: 'Description',
        multiline: true,
        rowsMax: "10",
        fullWidth: true,
        className: classes.fullField
      },

    ];

    return (
      <React.Fragment>

        {
          (error !== undefined) &&
          <SnackbarContent
            className={classes.error}
            message={
              <span className={classes.message}>
                <ErrorIcon className={`${classes.icon} ${classes.iconVariant}`} />
                {error.toString()}
              </span>
            }
          />
        }

        <Message message={message} isOpen={message ? true : false} />

        <Typography variant="h5" className={classes.title}>{formName} Property</Typography>

        <Form className={classes.form} onSubmit={handleSubmit(addProperty)}>

          {this.renderFields(fields)}

          <FormControl margin="normal" required fullWidth>
            <FormLabel component="legend">Upload Property Pictures </FormLabel>
            <Field 
              name="propertyImages" 
              component={UploadField} 
              label="Upload Property Pictures" 
              folderName={PROPERTY_FILES_FOLDER}
            />
          </FormControl>

          {
            propertyImages &&
            <FilesList
              list={propertyImages}
              deleteItem={deleteImage}
              folderName={PROPERTY_FILES_FOLDER}
            />
          }

          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Save Property
          </Button>

        </Form>

      </React.Fragment>
    );
  }
}

export default withStyles(styles)(PropertyForm);